/**
 * Mutations & Actions constants
 */

export const CURRENT_APP = "CURRENT_APP";
export const ACTION_CURRENT_APP = "ACTION_CURRENT_APP";

// export const GET_APP = "GET_APP";
// export const ACTION_GET_APP = "ACTION_GET_APP";

export const STORE_SUPPORTED_CURRENCIES = "STORE_SUPPORTED_CURRENCIES";
export const ACTION_STORE_SUPPORTED_CURRENCIES =
  "ACTION_STORE_SUPPORTED_CURRENCIES";

export const STORE_APPS = "STORE_APPS";
export const ACTION_STORE_APPS = "ACTION_STORE_APPS";

export const CREATE_APP = "CREATE_APP";
export const ACTION_CREATE_APP = "ACTION_CREATE_APP";

export const OPEN_APP = "OPEN_APP";
export const ACTION_OPEN_APP = "ACTION_OPEN_APP";

export const PUSH_PAYMENT = "PUSH_PAYMENT";
export const ACTION_PUSH_PAYMENT = "ACTION_PUSH_PAYMENT";

export const POP_PAYMENT = "POP_PAYMENT";
export const ACTION_POP_PAYMENT = "ACTION_POP_PAYMENT";

export const CLEAR_CACHED_PAYMENTS = "CLEAR_CACHED_PAYMENTS";
export const ACTION_CLEAR_CACHED_PAYMENTS = "ACTION_CLEAR_CACHED_PAYMENTS";

export const OPEN_APP_WITHDRAWS = "OPEN_APP_WITHDRAWS";
export const ACTION_OPEN_APP_WITHDRAWS = "ACTION_OPEN_APP_WITHDRAWS";

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const ACTION_TOGGLE_SIDEBAR = "ACTION_TOGGLE_SIDEBAR";

export const CATCH_RESPONSE_ERROR = "CATCH_RESPONSE_ERROR";
export const ACTION_CATCH_RESPONSE_ERROR = "ACTION_CATCH_RESPONSE_ERROR";

export const OPEN_APPLICAITON = "OPEN_APPLICAITON";
export const ACTION_OPEN_APPLICAITON = "ACTION_OPEN_APPLICAITON";

export const ACTION_EXPORT_DEPOSITS = "ACTION_EXPORT_DEPOSITS";
export const ACTION_EXPORT_WITHDRAWALS = "ACTION_EXPORT_WITHDRAWALS";

export const UNALLOCATED = "UNALLOCATED";
export const ACTION_UNALLOCATED = "ACTION_UNALLOCATED";

export const ACTION_EXPORT_UNALLOCATED = "ACTION_EXPORT_UNALLOCATED";

export const HIDE_AUTH_RESPONSE_BANNER = "HIDE_AUTH_RESPONSE_BANNER";

export const ACTION_EDIT_APP = "ACTION_EDIT_APP";

export const OPEN_INTERNAL_TRANSFERS = "OPEN_INTERNAL_TRANSFERS";
export const ACTION_OPEN_INTERNAL_TRANSFERS = "ACTION_OPEN_INTERNAL_TRANSFERS";
export const ACTION_EXPORT_TRANSFERS = "ACTION_EXPORT_TRANSFERS";

export const OPEN_SETTLEMENTS = "OPEN_SETTLEMENTS";
export const ACTION_OPEN_SETTLEMENTS = "ACTION_OPEN_SETTLEMENTS";

export const ACTION_EXPORT_SETTLEMENTS = "ACTION_EXPORT_SETTLEMENTS";
